import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './CancelPayment.css';
import API_URL from '../config';

const CancelPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('');

  // Récupère l'ID de la réservation depuis l'URL
  const bookingId = new URLSearchParams(location.search).get('bookingId');

  // Fonction pour annuler la réservation via une requête PATCH
  const handleCancel = async () => {
    if (!bookingId) return;

    try {
      await axios.patch(`${API_URL}/api/bookings/${bookingId}/cancel`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setMessage('Un problème est survenu lors de votre paiement. Votre réservation a donc été annulée');
    } catch (error) {
      setMessage("Erreur lors de l'annulation de la réservation.");
    }
  };

  // Annule la réservation lorsque le composant est monté
  useEffect(() => {
    handleCancel();
  }, [bookingId]);

  const handleRedirect = () => {
    navigate('/booking-calendar'); // Redirige vers la page des réservations
  };

  return (
    <div className="cancel-payment-container">
      <h2>Paiement annulé</h2>
      <p>{message || "Un problème est survenu lors de votre paiement. Vous pouvez re-essayer en allant dans l'onglet Mes réservations."}</p>
      <button onClick={handleRedirect} className="ok-button">Retour au calendrier</button>
    </div>
  );
};

export default CancelPayment;